import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { inject, observer } from "mobx-react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Store from "../store";
import {
  SSOExternalRoleDto,
  SSOPermissionCreateDto,
  SSOExternalUserGridListDto,
  SSOPermissionDto,
} from "../types";
import { useForm } from "react-hook-form";
import cx from "classnames";
import { Button } from "../../../../components";
import { BiPlus, BiTrash, BiPencil, BiUser } from "react-icons/bi";
import {
  ComboBoxData,
  MessageResultState,
} from "../../../../types/general-types";
import _ from "lodash";
import { toast } from "react-toastify";

interface IViewDetails {
  ExternalUserManagementStore?: Store;
  selectedRow: SSOExternalUserGridListDto;
  isShow: boolean;
  toggleModal: any;
  t: any;
}

const AssigningRoleToUserModal: FC<IViewDetails> = inject(
  "ExternalUserManagementStore"
)(
  observer((props: IViewDetails) => {
    const {
      ExternalUserManagementStore: store,
      isShow,
      toggleModal,
      selectedRow,
    } = props;
    const { t } = useTranslation();
    const { register, control, handleSubmit, errors, setValue, getValues } =
      useForm();
    const [data, setData] = useState<SSOPermissionCreateDto>({
      sSOExternalUserId: selectedRow.id,
      permissionsList: [],
    });
    // const [loading, setLoading] = useState<boolean>(false);
    const [permission, setPermission] = useState<string | undefined>();

    useEffect(() => {
      store?.GetUserPermissions(selectedRow.id).then((res) => {
        if (res.state === MessageResultState.SUCCESS) {
          setData({
            permissionsList: res.result.permissionsList,
            sSOExternalUserId: selectedRow.id,
          });
        }
      });
    }, [selectedRow.id, store]);

    const page = useMemo(() => {
      return (
        <Modal isOpen={isShow} toggle={toggleModal} className="modal-md">
          <ModalHeader toggle={toggleModal}>
            {selectedRow.nameSurname + " - " + t(" Role Assignment")}
          </ModalHeader>
          <ModalBody>
            <>
              <div className="row mb-2">
                <div className="col col-md-10">
                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={permission}
                    onChange={(event) => {
                      const value = event.target.value;
                      setPermission(value);
                    }}
                    // ref={register({
                    //   required: "Lütfen bu alanı doldurun.",
                    // })}
                    className={cx("form-control mt-2", {
                      "is-invalid": errors.name,
                    })}
                  />
                </div>
                <div className="col col-md-2 mt-2">
                  <Button
                    className="btn btn-primary"
                    style={{ float: "left" }}
                    icon={<BiPlus />}
                    tooltipText={t("Add Permission")}
                    onClick={() => {
                      if (
                        _.find(data.permissionsList, function (o) {
                          return o.permissionKey === permission;
                        })
                      ) {
                        toast.error(
                          t(
                            "The Same Permission Cannot Be Given to The User Again!"
                          )
                        );
                      } else {
                        const newItem: SSOPermissionDto = {
                          permissionKey: permission,
                          sSOPermissionId: 0,
                        };
                        if (data) {
                          setData({
                            ...data,
                            permissionsList: [
                              ...(data.permissionsList ?? []),
                              newItem,
                            ],
                          });
                          data?.permissionsList?.map((item) => {
                            return <div>{item.permissionKey}</div>;
                          });
                        }
                        setPermission("");
                      }
                    }}
                    // text={t("Add")}
                  />
                </div>
              </div>
              {data.permissionsList?.map((item) => {
                return (
                  <div className="row">
                    <div className="col col-md-10 mt-2">
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        value={item.permissionKey}
                      />
                    </div>
                    <div className="col col-md-2 mt-2">
                      <Button
                        className="btn btn-danger"
                        style={{ float: "left" }}
                        icon={<BiTrash />}
                        tooltipText={t("Delete Permission")}
                        onClick={(event: any) => {
                          if (
                            data &&
                            data.permissionsList &&
                            data.permissionsList?.length > 0
                          ) {
                            const options = _.filter(
                              data?.permissionsList,
                              (subitem) =>
                                item.permissionKey !== subitem.permissionKey
                            );
                            setData({
                              ...data,
                              permissionsList: options,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-light mr-auto" onClick={toggleModal}>
              <i className="fas fa-times mr-2"></i>
              {t("Close")}
            </button>
            <Button
              className="btn"
              style={{
                backgroundColor: "#23486A",
                color: "#faf5f5",
              }}
              onClick={handleSubmit(async () => {
                await store?.createPermission(data).then((res) => {
                  if (res.state === MessageResultState.SUCCESS) {
                    toggleModal();
                  }
                });
              })}
              icon={<i className="fas fa-save mr-2"></i>}
              text={t("Save")}
              showConfirm={true}
            />
          </ModalFooter>
        </Modal>
      );
    }, [
      isShow,
      toggleModal,
      selectedRow.nameSurname,
      t,
      permission,
      errors.name,
      data,
      handleSubmit,
      store,
    ]);

    return <>{page}</>;
  })
);

export default AssigningRoleToUserModal;
